import { trackPromise } from 'react-promise-tracker';
import { create } from 'zustand';
import { getNotificationStyle } from '../common/notification';
import { IApproveRequest, ICNDNApproval, ICNDNInitial, ICNDNRequest, ICNDNWaybill, ICreditNoteRequest, ICreditNoteWaybills, IDebitNoteRequest, INoteChildren, IUpdateCNDNRequest } from '../model/CNDNModel';
import { IPagination } from '../model/CommonModel';
import { ApproveByCFOService, ApproveByDirectorService, ApproveByDivisionService, ApproveByFinanceService, ApproveCreditNoteService, ApproveDebitNoteByIdService, ExportCnDnToExcelService, FetchFromOracleService, FilterCNWaybillService, GetCNDNWaybillHistoryService, GetCNDNWaybillSearchService, GetCNWaybillByIdService, GetCNWaybillService, GetConfirmedWaybillService, GetDNWaybillService, GetDebitNoteWaybillHistoryService, PrintCreditNoteService, PrintDebitNoteService, RePushToOracleService, SaveCNDNService, SaveCNService, SaveDebitNoteService, UpdateCreditDebitNoteService } from '../services/cndn-service';
import { TWO_HUNDRED_SUCCESS_CODE, downloadBlob, downloadURL, fileFormat } from '../utils/app-common';
import { responseData } from './common';

const initialValue: ICNDNInitial = {
    waybills: {},
    total: 0,
    search: [],
    dnWaybills: {},
    creditNoteResponse: {},
    debitNoteResponse: {},
    cnWaybills: [],
    waybillHistory: [],
    debitNoteWaybillHistory: [],
    approveCreditNoteResponse: undefined,
    approveDebitNoteResponse: undefined,
    updateCNDNNoteResponse: undefined,
    approvalResponse: undefined
};

const childNode = ({ child }: { child: INoteChildren }) => ({
    ...child,
    createdBy: child?.createdBy,
    createdDate: child?.createdDate,
    cnRequest: child?.cnRequest,
    waybillNo: child?.waybillNo,
    cnWaybillNo: child?.cnWaybillNo,
    amendCharge: child?.amendCharge,
    grossCharge: child?.grossCharge,
    vatAmount: child?.vatAmount,
    vatPercentage: child?.vatPercentage,
    intGrossCharge: child?.intGrossCharge,
    intVatValue: child?.intVatValue,
    intVatPercentage: child?.intVatPercentage,
    intVatAmount: child?.intVatAmount,
    totalGross: child?.totalGross,
    oracleInvoiceNumber: child?.oracleInvoiceNumber,
    remarks: child?.remarks
});

const parentNode = ({ item }: { item: ICreditNoteWaybills }) => ({
    cndnRequestNo: item?.cndnRequestNo,
    createdBy: item?.createdBy,
    createdById: item?.createdById,
    createdDate: item?.createdDate,
    customerSubAccount: item?.customerSubAccount,
    customerSubAccountCode: item?.customerSubAccountCode,
    industryGroup: item?.industryGroup,
    id: item?.id,
    status: item?.status,
    statusId: item?.statusId,
    subClientId: item?.subClientId,
    updatedBy: item?.updatedBy,
    updatedById: item?.updatedById,
    updatedDate: item?.updatedDate,
    approvedBy: item?.approvedBy,
    approvedByDirector: item?.approvedByDirector,
    approvedByDirectorId: item?.approvedByDirectorId,
    approvedByDirectorDate: item?.approvedByDirectorDate,
    approvedByFinance: item?.approvedByFinance,
    approvedByFinanceId: item?.approvedByFinanceId,
    approvedByFinanceDate: item?.approvedByFinanceDate,
    rejectedBy: item?.rejectedBy,
    remarks: item?.remarks,
    approvedByDivisionHead: item?.approvedByDivisionHead,
    approvedByDivisionHeadId: item?.approvedByDivisionHeadId,
    approvedByDivisionHeadDate: item?.approvedByDivisionHeadDate,
    approvedByCfo: item?.approvedByCfo,
    approvedByCfoId: item?.approvedByCfoId,
    approvedByCfoDate: item?.approvedByCfoDate,
    childNode: item?.children?.map((child: INoteChildren) => ({ ...childNode({ child }), cndnRequestNo: item?.cndnRequestNo }))
})
let CNDNStore = ((set, get) => ({
    ...initialValue,
    GetCNDNWaybillAction: async ({ pageNumber: pageNo = 0, pageSize = 50, financeConfirmed = false, directorConfirmed = false, isDirectorConfirmedSet = true, isFinanceConfirmedSet = true, divisionHeasdConfirmed = false, cfoConfirmed = false, isDivisionHeadConfirmedSet = true, isCfoConfirmedSet = true  }: IPagination) => {
        set({ waybills: {} });
        const request: IPagination = { pageNo, pageSize }; 
        if (isDirectorConfirmedSet) {
            request.directorConfirmed = directorConfirmed;
        }
        if (isFinanceConfirmedSet) {
            request.financeConfirmed = financeConfirmed;
        }
        if (isDivisionHeadConfirmedSet) {
            request.divisionHeasdConfirmed = divisionHeasdConfirmed;
        }
        if (isCfoConfirmedSet) {
            request.cfoConfirmed = cfoConfirmed;
        }
        const response = await GetCNWaybillService(request);
        const data = responseData(response?.data);
        const { totalPages, isLast, numberOfElements, page, totalNumberOfAllElements } = response?.data || {};
        const sData = data?.map((item: ICreditNoteWaybills) => parentNode({ item }));
        set({ waybills: { waybills: sData, totalPages, isLast, numberOfElements, totalNumberOfAllElements, page }, total: totalNumberOfAllElements });
    },
    GetConfirmedWaybillAction: async ({ pageNumber: pageNo = 1, pageSize = 50, financeConfirmed = false, directorConfirmed = false, isDirectorConfirmedSet = true, isFinanceConfirmedSet = true, divisionHeasdConfirmed = false, cfoConfirmed = false, isDivisionHeadConfirmedSet = true, isCfoConfirmedSet = true }: IPagination) => {
        set({ waybills: {} });
        const request: IPagination = { pageNo, pageSize }; 
        if (isDirectorConfirmedSet) {
            request.directorConfirmed = directorConfirmed;
        }
        if (isFinanceConfirmedSet) {
            request.financeConfirmed = financeConfirmed;
        }

        if (isDivisionHeadConfirmedSet) {
            request.divisionHeasdConfirmed = divisionHeasdConfirmed;
        }
        if (isCfoConfirmedSet) {
            request.cfoConfirmed = cfoConfirmed;
        }

        const response = await GetConfirmedWaybillService(request);
        const data = responseData(response?.data);
        const { totalPages, isLast, numberOfElements, page, totalNumberOfAllElements } = response?.data || {};
        const sData = data?.map((item: ICreditNoteWaybills) => parentNode({ item })
        );
        set({ waybills: { waybills: sData, totalPages, isLast, numberOfElements, totalNumberOfAllElements, page }, total: totalNumberOfAllElements });
    },
    GetDNWaybillAction: async ({ pageNumber: pageNo = 1, pageSize = 10 }: IPagination) => {
        set({ dnWaybills: {} });
        const response = await GetDNWaybillService({ pageNo, pageSize });
        const data = responseData(response?.data);
        const { totalPages, isLast, numberOfElements, page: pageNumber, totalNumberOfAllElements } = response?.data || {};

        const sData = data?.map((item: ICreditNoteWaybills) => parentNode({ item }));
        set({ dnWaybills: { dnWaybills: sData, totalPages, isLast, numberOfElements, totalNumberOfAllElements, pageNumber } });
    },
    GetCNDNWaybillSearchAction: async (request: ICNDNWaybill) => {
        set({ search: [] })
        const response = await GetCNDNWaybillSearchService(request);
        set({ search: responseData(response?.data) })
    },
    GetCNWaybillByIdAction: async (id: number) => {
        set({ cnWaybills: [] });
        const response = await GetCNWaybillByIdService(id);
        set({ cnWaybills: responseData(response?.data) })
    },
    GetCreditNoteWaybillHistoryAction: async (waybill: string) => {
        set({ waybillHistory: [] });
        const response = await GetCNDNWaybillHistoryService(waybill);
        set({ waybillHistory: responseData(response?.data) });
    },
    GetDebitNoteWaybillHistoryAction: async (waybill: string) => {
        set({ debitNoteWaybillHistory: [] });
        const response = await GetDebitNoteWaybillHistoryService(waybill);
        set({ debitNoteWaybillHistory: responseData(response?.data) });
    },
    SaveCNAction: async (request: ICreditNoteRequest) => {
        const response = await SaveCNService(request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({ creditNoteResponse: responseData(response?.data) });
            trackPromise(get().GetCNDNWaybillAction({ pageNumber: 1, pageSize: 50, financeConfirmed: false }), 'get-cn-area');
        }
    },
    SaveCNDNAction: async (request: ICNDNRequest) => {
        const response = await SaveCNDNService(request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const data = responseData(response?.data);
            const { successWayBillList } = data || {};
            set({ creditNoteResponse: data });
            if (successWayBillList?.length) {
                getNotificationStyle(response);
                trackPromise(get().GetCNDNWaybillAction({ pageNumber: 1, pageSize: 50, isDirectorConfirmedSet: false, isFinanceConfirmedSet: false }), 'get-cn-area');
            }
        };
    },
    SaveDebitNoteAction: async (request: IDebitNoteRequest) => {
        const response = await SaveDebitNoteService(request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({ debitNoteResponse: responseData(response?.data) });
            trackPromise(get().GetCNDNWaybillAction({ pageNumber: 1, pageSize: 10 }), 'get-cn-area');
        }
    },
    UpdateCreditDebitNoteAction: async ({ id, request, getData }: { id: number, request: IUpdateCNDNRequest, getData: () => void }) => {
        const response = await UpdateCreditDebitNoteService({ id, request });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({ updateCNDNNoteResponse: responseData(response?.data) });
            getData();
        }
    },
    ApproveDebitNoteByIdAction: async (request: Partial<Omit<IApproveRequest, 'cnRequestNo'>>) => {
        const response = await ApproveDebitNoteByIdService(request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({ approveDebitNoteResponse: response?.status });
            trackPromise(get().GetDNWaybillAction({ pageNumber: 1, pageSize: 50, financeConfirmed: false }), 'get-cn-area');
        }
    },
    ApproveCreditNoteAction: async (request: Partial<Omit<IApproveRequest, 'dnRequestNo'>>) => {
        const response = await ApproveCreditNoteService(request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            trackPromise(get().GetCNDNWaybillAction({ pageNumber: 1, pageSize: 50, financeConfirmed: false }), 'get-cn-area');
            set({ approveCreditNoteResponse: response?.status });
        }
    },
    PrintCreditNoteAction: async (id?: number) => {
        const response = await PrintCreditNoteService(id);
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(downloadURL(data?.response), 'get-cn-print-area');
        }
    },
    PrintDebitNoteAction: async (id?: number) => {
        const response = await PrintDebitNoteService(id);
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(downloadURL(data?.response), 'get-cn-print-area');
        }
    },
    ApproveByFinanceAction: async (request: ICNDNApproval, current: number, pageSize: number) => {
        const response = await ApproveByFinanceService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ approvalResponse: statusCode });
            trackPromise(get().GetCNDNWaybillAction({ pageNumber: current, pageSize: pageSize, divisionHeasdConfirmed: true }), 'get-cn-area');
        }
    },
       ApproveByDivisionHeadAction: async (request: ICNDNApproval, current: number, pageSize: number) => {
        const response = await ApproveByDivisionService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ approvalResponse: statusCode });
            trackPromise(get().GetCNDNWaybillAction({ pageNumber: current, pageSize: pageSize, directorConfirmed: true }), 'get-cn-area');
        }
    },
    ApproveByDirectorAction: async (request: ICNDNApproval, current: number, pageSize: number) => {
        const response = await ApproveByDirectorService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ approvalResponse: statusCode });
            trackPromise(get().GetCNDNWaybillAction({ pageNumber: current, pageSize: pageSize }), 'get-cn-area');
        }
    },
    ApproveByCFOAction: async (request: ICNDNApproval, current: number, pageSize: number) => {
        const response = await ApproveByCFOService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ approvalResponse: statusCode });
            trackPromise(get().GetCNDNWaybillAction({ pageNumber: current, pageSize: pageSize, financeConfirmed: true }), 'get-cn-area');
        }
    },
FilterCNDNWaybillAction: async ({ pageNumber: pageNo = 0, pageSize = 3000, financeConfirmed = false, directorConfirmed = false, isDirectorConfirmedSet = true, isFinanceConfirmedSet = true, customer = undefined, industryGroup = undefined, waybillNo = undefined, divisionHeasdConfirmed = false, cfoConfirmed = false, isDivisionHeadConfirmedSet = true, isCfoConfirmedSet = true , fromDate = undefined, toDate = undefined , fromApprovalDate = undefined, toApprovalDate = undefined , approvalDateType = undefined  }: IPagination) => {        set({ waybills: {} });
        const request: IPagination = { pageNo, pageSize }; 
        if (isDirectorConfirmedSet) {
            request.directorConfirmed = directorConfirmed;
        }
        if (isFinanceConfirmedSet) {
            request.financeConfirmed = financeConfirmed;
        }
        if (isDivisionHeadConfirmedSet) {
            request.divisionHeasdConfirmed = divisionHeasdConfirmed;
        }
        if (isCfoConfirmedSet) {
            request.cfoConfirmed = cfoConfirmed;
        }
        if(customer){
            request.customer = customer;
        }
        if(industryGroup){
            request.industryGroup = industryGroup;
        }
        if(waybillNo){
            request.waybillNo = waybillNo;
        }


             if (fromDate !== undefined) {
            request.fromDate = fromDate;
        }
        if (toDate !== undefined) {
            request.toDate = toDate;
        }

        if(approvalDateType !== undefined){
            request.approvalDateType = approvalDateType;
            if (fromApprovalDate !== undefined) {
                request.fromApprovalDate = fromApprovalDate;
            }
            if (toApprovalDate !== undefined) {
                request.toApprovalDate = toApprovalDate;
            }
        }


        const response = await FilterCNWaybillService(request);
        const data = responseData(response?.data);
        const { totalPages, isLast, numberOfElements, page, totalNumberOfAllElements } = response?.data || {};
        const sData = data?.map((item: ICreditNoteWaybills) => parentNode({ item }));
        set({ waybills: { waybills: sData, totalPages, isLast, numberOfElements, totalNumberOfAllElements, page } });
    },
    ExportCnDnToExcelAction: async ({ pageNumber: pageNo = 0, pageSize = 50, financeConfirmed = false, directorConfirmed = false, isDirectorConfirmedSet = true, isFinanceConfirmedSet = true, customer = undefined, industryGroup = undefined, divisionHeasdConfirmed = false, cfoConfirmed = false, isDivisionHeadConfirmedSet = true, isCfoConfirmedSet = true  }: IPagination) => {
        const request: IPagination = { pageNo, pageSize, financeConfirmed, directorConfirmed }; 
        if (isDirectorConfirmedSet) {
            request.directorConfirmed = directorConfirmed;
        }
        if (isFinanceConfirmedSet) {
            request.financeConfirmed = financeConfirmed;
        }
        if (isDivisionHeadConfirmedSet) {
            request.divisionHeasdConfirmed = divisionHeasdConfirmed;
        }
        if (isCfoConfirmedSet) {
            request.cfoConfirmed = cfoConfirmed;
        }
        if(customer){
            request.customer = customer;
        }
        if(industryGroup){
            request.industryGroup = industryGroup;
        }
        const response = await ExportCnDnToExcelService(request);
        const { fileName, fileType, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat[fileType]);
    },
    RePushToOracleAction: async (id: number) => {
        const response = await RePushToOracleService(id);
        getNotificationStyle(response);
        // set({ debitNoteWaybillHistory: responseData(response?.data) });
    },
    FetchFromOracleAction: async (waybillNo: string, onSuccess: () => void) => {
        const response = await FetchFromOracleService(waybillNo);
        getNotificationStyle(response);
        onSuccess();
    },
}))

export const useCNDNStore = create(CNDNStore)